import type { Partner } from "@expert/shared-types";

export type EventType = "expertAssist.loginSuccess" | "expertAssist.reset";

export interface Expert {
    __typename: "Expert";
    callSid?: string;
    partner?: Partner;
    employeeId: string;
    eventType?: EventType;
    lastUpdated?: string;
    sessionId: string;
}

export interface UpdateExpertMutation {
    updateExpert?: Expert | null;
}

export const updateExpert = /* GraphQL */ `
    mutation UpdateExpert($input: UpdateExpertInput!) {
        updateExpert(input: $input) {
            callSid
            partner
            employeeId
            eventType
            lastUpdated
            sessionId
            __typename
        }
    }
`;
